export const PROFESSIONAL_ROLE_OTHER_ID = '40';
